'use client'

import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'
import Link from 'next/link'

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
}

const OnlinePsychiatryCTA: React.FC = () => (
  <section className="py-12 sm:py-16 lg:py-20 px-4 bg-emerald-600">
    <div className="max-w-4xl mx-auto text-center">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={fadeIn}
      >
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif text-white mb-4 sm:mb-6">
          Access Expert Mental Health Care, Conveniently and Confidentially
        </h2>
        <p className="text-base sm:text-xl text-emerald-100 mb-8 sm:mb-12 leading-relaxed">
          Experience the ReACH standard of care from wherever you are. Our
          online services make prioritizing your mental wellness easier than
          ever.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
          <Link href="/book" className="w-full sm:w-auto">
            <Button className="w-full bg-white text-emerald-600 hover:bg-gray-100 px-8 py-4 rounded-full text-base sm:text-lg transition-transform duration-300 hover:scale-105">
              Book an Online Session
            </Button>
          </Link>
          <Link
            href="/services"
            className="text-white hover:text-emerald-200 text-base sm:text-lg relative group flex items-center justify-center"
          >
            View All Our Services
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full" />
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
)

export default OnlinePsychiatryCTA
